import {
  TasksMyTodoCompletableByDateDataQuery,
  TasksMyTodoCompletableByDateDataQueryVariables,
} from 'graphql-common';
import { useLazyQuery } from '@apollo/client/react';
import { addDaysFn, endOfDayFn } from '@lib/utils/dateTimeHelpers';

export const fetchCompletableTasks = (
  fetchTasksMyTodoCompletableByDateData: useLazyQuery.ExecFunction<
    TasksMyTodoCompletableByDateDataQuery,
    TasksMyTodoCompletableByDateDataQueryVariables
  >,
  syncTrackerDays: number,
) => {
  return fetchTasksMyTodoCompletableByDateData({
    variables: {
      date: syncTrackerDays
        ? addDaysFn(endOfDayFn(new Date()), +syncTrackerDays)
        : endOfDayFn(new Date()),
    },
  });
};
